/**
 * Recibe un objeto y lo retorna como string en base64
 * @param {object} objectData - El objeto a encriptar
 * @return {string|null}
 */
export const encryptObject = (objectData) => {
  try {
    const jsonString = JSON.stringify(objectData)
    const utf8Bytes = new TextEncoder().encode(jsonString)
    const base64 = btoa(String.fromCharCode(...utf8Bytes))
    return base64
  } catch (error) {
    console.error(error)
    return null
  }
}

/**
 * Recibe un string en base64 y lo retorna como objeto
 * @param {string} encryptedObject - El objeto encriptado en base64
 * @return {object|null}
 */
export const decryptObject = (encryptedObject) => {
  if (!encryptedObject) return null
  try {
    const binaryString = atob(encryptedObject)
    const bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0))
    const jsonString = new TextDecoder().decode(bytes)
    return JSON.parse(jsonString)
  } catch (error) {
    console.error(error)
    return null
  }
}
